import React, { useState, useEffect, SetStateAction } from 'react'
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { ko } from 'date-fns/locale/ko'
import { Box } from '@mui/material';
import Icon_Calender from '@mui/icons-material/CalendarTodayOutlined';
import { format, parse } from 'date-fns';

//DatePickerCustom
//DatePicker 컴포넌트

//작동에는 문제가 없으나 포커스 에러로그가 출력되는 현상이 있음 -> 수정필요함

interface Props{
  textAlign? : string
  start_date? : string | null
  setstart_date? : React.Dispatch<SetStateAction<any>>
}

const safeToDate = (value: string | Date | null | undefined): Date | null => {
  if (!value) return null;
  if (typeof value === 'string') {
    return parse(value, 'yyyy-MM-dd', new Date()); // ✅ 핵심
  }
  return value;
};

const DatePickerAddEtc = ({textAlign, start_date, setstart_date}:Props) => {
  const [startDate, setStartDate] = useState<Date | null>(safeToDate(start_date));
  const [open,setOpen] = useState(false)

  useEffect(() => {
    setStartDate(safeToDate(start_date));
  }, [start_date]);

  //일부러 클린업 안함 >> 기간입력으로 바꿔도 안 없어지게
  // useEffect(() => {
  //   return () => {
  //       setField('etcstartdate', '');
  //   };
  // }, []);

  const handleStart = (newValue: Date | null) => {
    setStartDate(newValue);
    if (newValue) {
      setstart_date?.(format(newValue, 'yyyy-MM-dd'))
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ko}>
      <Box display="flex" alignItems="center" gap="5px" width="100%" height="100%">
        <DatePicker
          open={open}
          onOpen={()=>setOpen(true)}
          onClose={()=>setOpen(false)}
          value={startDate}
          onChange={handleStart}
          format="yyyy-MM-dd"
          slotProps={{
            textField: {
              placeholder:'날짜',
              //박스크기 스타일조정
              sx: {
                height:'100%',
                width:'100%',
                backgroundColor:'white',
                '& .MuiInputBase-root': {
                  height: '100%',
                },
                '& input': {
                  fontSize: '14px',
                  color: '#D1D1D1',
                  textAlign: textAlign || 'left',
                },
              },
              //내부 이미지 조정
              InputProps: {
                endAdornment: (
                  <Icon_Calender sx={{color:'#D1D1D1', width:'24px', height:'24px'}}/>
                ),
                onClick:()=>setOpen(true)
              },
            },
          }}
          slots={{
            toolbar: undefined, // ✅ 상단 선택된 날짜 텍스트 제거
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}

export default DatePickerAddEtc